export const classSubjectApi = {
    heading:[
        
        {
            head:"Class ID"
        },
        {
            head:"Class Name"
        },
        {
            head:"Subject Name"
        },
        {
            head:"Total Subject"
        },
        {
            head:"Action"
        },
    ],
    data:[
       {
            classid:435,
            classname:"Class 4",
            subjectname:"ART & CRAFT,ENGLISH LITERATURE,ICT,ARABIC,ENGLISH LANGUAGE,BENGALI,MORAL SCIENCE,SCIENCE,ISLAMIAT,SOCIAL STUDIES,MATHEMATICS,MUSIC,ON TRACK ,GAMES,LIBRARY,EXTRA CURRICULAM ACTIVITIES,ENGLISH WRITTEN",
            totalsubject:7,
            action:"./assets/images/dashboards/adminDashboard/flexvalue/tableactionicon.png"
       },
      
    
      
     
   
       
    ]
}